import { render, staticRenderFns } from "./Postcodes.vue?vue&type=template&id=4f0648e0&scoped=true&"
import script from "./Postcodes.vue?vue&type=script&lang=js&"
export * from "./Postcodes.vue?vue&type=script&lang=js&"
import style0 from "./Postcodes.vue?vue&type=style&index=0&id=4f0648e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0648e0",
  null
  
)

export default component.exports